import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Toaster } from 'sonner';
import App from './App';
import { SoundBridge } from './lib/soundBridge';
import './index.css';

// TODO-MDC-23: registrar el service worker al cargar la app (no solo
// cuando el usuario activa push). Esto cumple los criterios de PWA
// installable de Chrome/Edge/Android — sin SW registrado, el evento
// `beforeinstallprompt` no se dispara y el wizard de "Instalar app"
// queda inutilizable.
//
// El registro es idempotente, así que si ya estaba registrado solo
// devuelve la registration existente. En dev (Vite HMR) puede fallar
// — silenciamos el error.
if (typeof window !== 'undefined' && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js', { scope: '/' }).catch((err) => {
      // En dev a veces el SW choca con el HMR. No es bloqueante.
      if (import.meta.env.DEV) {
        console.warn('[sw] registro falló (probablemente HMR):', err);
      }
    });
  });
}

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('No se encontró el nodo #root');

createRoot(rootEl).render(
  <StrictMode>
    <BrowserRouter>
      <App />
      <Toaster
        position="top-right"
        richColors
        closeButton
        toastOptions={{
          style: {
            borderRadius: '18px',
            fontFamily: 'Inter, system-ui, sans-serif',
          },
        }}
      />
      <SoundBridge />
    </BrowserRouter>
  </StrictMode>,
);
